
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokohlapurcab() {



  const cardData =
  {
    keyword: 'Pune to Kolhapur Cab Service',
    heading: 'AB Ghule Cabs: Pune to Kolhapur Cab Service',
    headingDescription: 'AB Ghule Cabs provides reliable and comfortable Pune to Kolhapur cab services. Whether you are traveling for business, leisure, or a spiritual visit, our fleet of well-maintained vehicles and professional drivers will ensure a smooth and enjoyable journey. With competitive pricing and excellent customer service, we make your trip to Kolhapur hassle-free. Pune to Kolhapur is approximately 230 km.',

    top: 'Top Places to Visit in Kolhapur with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Mahalakshmi Temple",
    description: "One of the most revered pilgrimage sites in India, this temple dedicated to Goddess Mahalakshmi attracts thousands of devotees every year. It is known for its architectural beauty and spiritual significance."
  },
  {
    title: "Rankala Lake",
    description: "A scenic lake perfect for a peaceful evening, Rankala Lake is surrounded by beautiful gardens and offers boat rides, making it a popular spot for relaxation and family outings."
  },
  {
    title: "Panhala Fort",
    description: "Situated atop a hill, Panhala Fort offers breathtaking views of the surrounding landscape and has historical significance related to the Maratha Empire. It is one of the best-preserved forts in Maharashtra."
  },
  {
    title: "Shivaji Memorial",
    description: "Located near Rankala Lake, this memorial honors the legacy of the Maratha king, Shivaji Maharaj, and is a popular spot for history lovers."
  },
  {
    title: "Sankalpa Lake",
    description: "A tranquil spot for nature lovers, Sankalpa Lake is perfect for a relaxing outing, surrounded by lush greenery."
  },
  {
    title: "Jyotiba Temple",
    description: "Situated on the Jyotiba hill, this temple dedicated to Lord Jyotiba is a major pilgrimage site and offers a panoramic view of Kolhapur and its surroundings."
  },
  {
    title: "Kedya Fort",
    description: "A lesser-known fort with historical importance, Kedya Fort is a quiet place to explore and offers a rich historical experience with scenic surroundings."
  },
  {
    title: "New Palace",
    description: "An architectural marvel, the New Palace in Kolhapur was built in the 19th century and is home to the royal family. It also houses a museum that showcases royal artifacts and memorabilia."
  },
  {
    title: "Binkhambi Ganesh Mandir",
    description: "A unique temple dedicated to Lord Ganesha, Binkhambi Ganesh Mandir is known for its distinctive architecture, with pillars standing without support."
  },
  {
    title: "Radhanagari Dam",
    description: "Located around 50 km from Kolhapur, the Radhanagari Dam is an excellent place for nature lovers, offering scenic views and opportunities for picnics and photography."
  }
    ],


    services: [
        {
          "name": "Pune to Kolhapur Cab",
          description: "AB Ghule Cabs offers reliable and comfortable taxi services from Pune to Kolhapur. Whether for a religious trip or a business visit, our fleet of vehicles ensures a smooth and pleasant journey."
        },
        {
          "name": "Pune to Kolhapur Cab Service",
          description: "For a hassle-free trip, book our Pune to Kolhapur cab service. We offer a variety of vehicles to choose from, ensuring comfort and reliability for your journey."
        },
        {
          "name": "Pune to Kolhapur Car Rental",
          description: "AB Ghule Cabs provides affordable car rental options for traveling from Pune to Kolhapur. Whether you need a one-way or round-trip, our cars are well-maintained to ensure a comfortable journey."
        },
        {
          "name": "One Way Cab from Pune to Kolhapur",
          description: "Travel in comfort with AB Ghule Cabs’ one-way cab service from Pune to Kolhapur. Book your ride online for a convenient and economical one-way journey."
        },
        {
          "name": "One Way Cab Pune to Kolhapur",
          description: "For a seamless one-way taxi service from Pune to Kolhapur, AB Ghule Cabs provides affordable and timely options. Book now and enjoy a safe and comfortable ride."
        },
        {
          "name": "Pune Airport to Kolhapur Cab",
          description: "AB Ghule Cabs offers reliable airport-to-Kolhapur cab services. If you're arriving at Pune Airport, we’ll pick you up and take you directly to Kolhapur in comfort."
        },
        {
          "name": "Pune Kolhapur Cab Service",
          description: "Choose AB Ghule Cabs for your Pune to Kolhapur journey. Our professional drivers ensure a smooth ride with flexible pick-up and drop-off times to suit your schedule."
        },
        {
          "name": "Pune to Kolhapur by Car",
          description: "Travel from Pune to Kolhapur by car with AB Ghule Cabs. Our well-maintained cars offer a comfortable, stress-free journey, whether you're traveling for business or leisure."
        },
        {
          "name": "Pune to Kolhapur Cab Booking",
          description: "Book your Pune to Kolhapur cab with AB Ghule Cabs. We offer easy online booking and a wide range of vehicles to ensure your journey is both comfortable and affordable."
        },
        {
          "name": "Pune to Kolhapur Cab Price",
          description: "AB Ghule Cabs offers competitive pricing for your Pune to Kolhapur journey. Get the best value for money with no hidden charges and excellent service."
        },
        {
          "name": "Pune to Kolhapur Car Hire",
          description: "For your car hire needs from Pune to Kolhapur, AB Ghule Cabs provides flexible and affordable options. Enjoy a comfortable ride with a range of vehicles to choose from."
        },
        {
          "name": "Pune to Kolhapur One Way Cab",
          description: "Book a one-way cab from Pune to Kolhapur with AB Ghule Cabs. Our services are affordable and provide you with a smooth and comfortable travel experience."
        },
        {
          "name": "Pune to Kolhapur Taxi Charges",
          description: "AB Ghule Cabs provides transparent taxi charges for your trip from Pune to Kolhapur. Our pricing includes all relevant fees, ensuring no hidden costs."
        },
        {
          "name": "Pune to Admapur Cab Service",
          description: "For reliable cab services from Pune to Admapur, choose AB Ghule Cabs. We offer timely and comfortable rides to ensure a smooth journey."
        },
        {
          "name": "Pune to Admapur Balumama Cabs",
          description: "Travel from Pune to Admapur Balumama with AB Ghule Cabs. Our service offers affordable pricing and comfortable vehicles, ensuring a pleasant trip to this spiritual destination."
        },
        {
          "name": "Pune to Jyotirlinga Darshan Cab Service",
          description: "AB Ghule Cabs offers dedicated taxi services for Jyotirlinga darshan from Pune. Enjoy a comfortable ride to all the Jyotirlinga locations with our experienced and professional drivers."
        },
        {
          "name": "Pune to Mahalaxmi Temple Kolhapur Taxi Service",
          description: "Visit the Mahalaxmi Temple in Kolhapur with AB Ghule Cabs. Our taxi service is tailored for your religious journey, offering comfort, reliability, and punctuality."
        },
        {
          "name": "Pune to Sadeteen Shaktipeeth Cab Package",
          description: "For a spiritual journey to Sadeteen Shaktipeeth, book your cab with AB Ghule Cabs. We provide special packages with flexible pricing to make your visit comfortable and memorable."
        },
        {
          "name": "Pune to Kolhapur Taxi",
          description: "Choose AB Ghule Cabs for a reliable and comfortable Pune to Kolhapur taxi service. Our fleet includes a variety of vehicles to suit your travel needs."
        },
        {
          "name": "Pune to Kolhapur Cab Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Kolhapur Cab. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData: [
        ["Pune to Kolhapur Cab", "- Pune to Kolhapur Cab Service"],
        ["Pune to Kolhapur car rental", "- One way cab from Pune to Kolhapur"],
        ["One way cab Pune to Kolhapur", "- Pune Airport to Kolhapur cab"],
        ["Pune Kolhapur cab service", "- Pune to Kolhapur by car"],
        ["Pune to Kolhapur cab price", "- Pune to Kolhapur car hire"],
        ["Pune to Kolhapur one way cab", "- Pune to Kolhapur taxi charges"],
        ["Pune to Admapur cab service", "- Pune to Admapur Balumama Cabs"],
        ["Pune to Jyotirlinga darshan Cab Service", "- Pune to Mahalaxmi Temple Kolhapur taxi service"],
        ["Pune to Sadeteen Shaktipeeth cab package", "- Pune to Kolhapur taxi"],
        ["Pune to Kolhapur cab booking", ""]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Punctual Service",
          WhyChoosedescription: "At AB Ghule Cabs, we understand the importance of reaching your destination on time. Our drivers ensure that your ride from Pune to Kolhapur is timely, allowing you to enjoy your trip without any worries about delays."
        },
        {
          WhyChooseheading: "Comfortable and Well-Maintained Vehicles",
          WhyChoosedescription: "Whether you're traveling solo or with a group, we offer a range of vehicles, including sedans and SUVs, all kept clean and in top condition. Our vehicles are designed to ensure a comfortable and smooth journey."
        },
        {
          WhyChooseheading: "Experienced and Professional Drivers",
          WhyChoosedescription: "Our drivers are highly trained, experienced, and familiar with the best routes between Pune and Kolhapur. They are committed to providing a safe and hassle-free journey, ensuring that you can relax during your trip."
        },
        {
          WhyChooseheading: "Affordable Pricing",
          WhyChoosedescription: "We offer competitive and transparent pricing for the Pune to Kolhapur route. There are no hidden charges, and we make sure you know the fare upfront before you book your cab."
        },
        {
          WhyChooseheading: "Safe and Secure Travel",
          WhyChoosedescription: "Your safety is our priority. All of our drivers undergo thorough background checks, and our vehicles are equipped with the latest safety features, ensuring a secure journey throughout the ride."
        },
        {
          WhyChooseheading: "Flexible Booking Options",
          WhyChoosedescription: "Booking a cab with AB Ghule Cabs is easy. You can book online via our website or app, or simply call our customer service for assistance. We are always available to make your booking process smooth and quick."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "Whether it's a day trip or late-night travel, AB Ghule Cabs is available 24/7 to provide you with a reliable ride from Pune to Kolhapur. Our services are designed to suit your schedule."
        },
        {
          WhyChooseheading: "Personalized Travel Experience",
          WhyChoosedescription: "We offer customized travel experiences based on your preferences. Whether you're traveling for leisure, business, or a special event, we cater to all your needs to ensure a pleasant journey."
        }
      ]
      
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How do I book a cab from Pune to Kolhapur?',
      answer: 'You can book your cab through our website, mobile app, or by calling our customer service team. We offer an easy booking process for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for the Pune to Kolhapur trip?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, ensuring a comfortable ride for both solo travelers and groups.',
    },
    {
      id: 'FAQ3',
      question: 'Are the drivers experienced with the Pune to Kolhapur route?',
      answer: 'Yes, our drivers are familiar with the best routes between Pune and Kolhapur, ensuring a smooth and efficient journey.',
    },
    {
      id: 'FAQ4',
      question: 'How much does a cab from Pune to Kolhapur cost?',
      answer: 'We provide competitive pricing, with no hidden charges. The fare will depend on the type of vehicle and the distance, but we offer affordable options that suit all budgets.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round trip from Pune to Kolhapur?',
      answer: 'Yes, we offer round-trip services for customers traveling from Pune to Kolhapur and back. You can book a round trip at a reasonable price.',
    },
    {
      id: 'FAQ6',
      question: 'Is there any waiting time charge for the trip?',
      answer: 'Our pricing is transparent, and any waiting time charges will be communicated to you upfront. We strive to make the pricing clear and fair for all our customers.',
    },
    {
      id: 'FAQ7',
      question: 'How far in advance should I book a cab?',
      answer: 'It’s best to book your cab at least a few hours in advance, especially for early morning or late-night travel. Booking early ensures vehicle availability and a smooth travel experience.',
    },
    {
      id: 'FAQ8',
      question: 'Can I make changes to my booking?',
      answer: 'Yes, you can modify your booking by contacting our customer service team. We are happy to accommodate changes as long as they are within a reasonable time frame.',
    },
    {
      id: 'FAQ9',
      question: 'Is it safe to travel with AB Ghule Cabs from Pune to Kolhapur?',
      answer: 'Yes, your safety is our top priority. Our vehicles are regularly maintained, and all drivers undergo background checks to ensure a secure journey.',
    },
    {
      id: 'FAQ10',
      question: 'What if I need assistance during the trip?',
      answer: 'If you need assistance during your journey, you can contact our driver or customer service at any time. We are committed to providing you with a smooth and hassle-free ride.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Ajay Deshmukh',
      feedback: 'I recently traveled from Pune to Kolhapur with AB Ghule Cabs, and I was very impressed by the quality of service. The car was clean, the driver was experienced and friendly, and the trip was very comfortable. I would definitely recommend this service for anyone traveling to Kolhapur.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Shalini Patel',
      feedback: 'The journey from Pune to Kolhapur was smooth and pleasant. The driver knew the best routes and ensured we were comfortable throughout the trip. AB Ghule Cabs provides excellent service, and I will definitely use their services for future trips.',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Kolhapur Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Reliable and affordable Pune to Kolhapur cabs with AB Ghule Cabs. Offering one-way and round trip taxi services, car rentals, and Kolhapur darshan options. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Kolhapur Cab, Pune to Kolhapur Cab Service, Pune to Kolhapur car rental, One way cab from Pune to Kolhapur, One way cab Pune to Kolhapur, Pune airport to Kolhapur cab, Pune Kolhapur cab service, Pune to Kolhapur by car, Pune to Kolhapur cab booking, Pune to Kolhapur cab price, Pune to Kolhapur car hire, Pune to Kolhapur one way cab, Pune to Kolhapur taxi charges, Pune to Admapur cab service, Pune to Admapur Balumama Cabs, Pune to Jyotirlinga Darshan Cab Service, Pune to Mahalaxmi Temple Kolhapur taxi service, Pune to Sadeteen Shaktipeeth cab package, Pune to Kolhapur taxi" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Kolhapur Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Reliable and affordable Pune to Kolhapur cabs with AB Ghule Cabs. Offering one-way and round trip taxi services, car rentals, and Kolhapur darshan options. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-kolhapur-cab.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-kolhapur-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Kolhapur Cabs",
        description: "Reliable and affordable Pune to Kolhapur cabs with AB Ghule Cabs. Offering one-way and round trip taxi services, car rentals, and Kolhapur darshan options. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-kolhapur-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-kolhapur-cab.jpg",
        "image": "https://abghulecabs.com/images/pune-to-kolhapur-cab.jpg",
        "priceRange": "₹1500 - ₹3500",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-kolhapur-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "180"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal P"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "AB Ghule Cabs provided excellent service for my trip to Kolhapur. The driver was on time, and the car was clean and comfortable."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali K"
            },
            "datePublished": "2024-09-30",
            "reviewBody": "The Pune to Kolhapur cab service was very good. The driver was professional, and the journey was smooth. Would recommend for long trips."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Kolhapur Cabs",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-kolhapur-cabs"
        },
        "keywords": "Pune to Kolhapur Cab, Pune to Kolhapur Cab Service, Pune to Kolhapur car rental, One way cab from Pune to Kolhapur, One way cab Pune to Kolhapur, Pune airport to Kolhapur cab, Pune Kolhapur cab service, Pune to Kolhapur by car, Pune to Kolhapur cab booking, Pune to Kolhapur cab price, Pune to Kolhapur car hire, Pune to Kolhapur one way cab, Pune to Kolhapur taxi charges, Pune to Admapur cab service, Pune to Admapur Balumama Cabs, Pune to Jyotirlinga Darshan Cab Service, Pune to Mahalaxmi Temple Kolhapur taxi service, Pune to Sadeteen Shaktipeeth cab package, Pune to Kolhapur taxi"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/36.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetokohlapurcab;